import {
  DropdownMenuContent,
  DropdownMenuRoot,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@synoptic/ui-kit/dropdown-menu/dropdown-menu.js';
import { MenuIcon } from '@synoptic/ui-kit/icons/react/menu.js';
import { UserCircleIcon } from '@synoptic/ui-kit/icons/react/user-circle.js';
import { useLocation } from 'react-router';
import { getRedirectLink } from '@/routes-utils/get-redirect-link.ts';
import { paths } from '@/routes-utils/paths.ts';
import { useAppLoader } from '../loader.ts';
import { useAuthInfo } from '../use-auth-info.ts';
import { bar, moreMenu } from './mobile-nav-v2.css.ts';
import { NavItemByIdV2 } from './nav-item-by-id-v2.tsx';
import { NavButtonItemV2, NavLinkItemV2 } from './nav-item-v2.tsx';
import {
  mobileBarItemsV2,
  mobileMoreItemsV2,
  visibleNavItemsV2,
} from './nav-items-v2.tsx';
import { NavVariantV2Provider } from './nav-variant-v2.ts';
import { ProfileActionsV2 } from './profile-menu-v2.tsx';

export const MobileNavV2 = () => {
  const { pathname } = useLocation();
  const { authenticated } = useAppLoader();
  const { isAdmin } = useAuthInfo();
  const loginTo = getRedirectLink(paths.login, pathname);

  return (
    <NavVariantV2Provider value="bar">
      <nav className={bar} aria-label="Main">
        {mobileBarItemsV2.map((id) => (
          <NavItemByIdV2 key={id} id={id} />
        ))}
        <DropdownMenuRoot>
          <DropdownMenuTrigger>
            <NavButtonItemV2 icon={<MenuIcon />} label="More" />
          </DropdownMenuTrigger>
          <DropdownMenuContent className={moreMenu} side="top" align="end">
            <NavVariantV2Provider value="menu">
              {visibleNavItemsV2(mobileMoreItemsV2, isAdmin).map((id) => (
                <NavItemByIdV2 key={id} id={id} />
              ))}
              {authenticated ? (
                <>
                  <DropdownMenuSeparator />
                  <ProfileActionsV2 />
                </>
              ) : null}
            </NavVariantV2Provider>
          </DropdownMenuContent>
        </DropdownMenuRoot>
        {authenticated ? null : (
          <NavLinkItemV2
            to={loginTo}
            icon={<UserCircleIcon />}
            label="Log in"
          />
        )}
      </nav>
    </NavVariantV2Provider>
  );
};
